// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2R60T","validationTips":"StatementDescriptor_validationTips__23CtS"};